// ------------------------------------------------------------
// 流入元（utm）の保持（公式サイト連携 H3）
//   - 予約システムへの着地時に URL の utm_* / lng を sessionStorage に保存
//   - 同一セッション内で新しい utm_* 付きURLから来た場合のみ上書き（last-touch）
//   - 予約作成時に getAttribution() の値を API に送る（サーバー側でも再検証）
//   - 個人情報は扱わない
// ------------------------------------------------------------
const KEY = 'sd_attribution';
const MAX_LEN = 100;
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'] as const;
const LANGS = ['ja', 'en', 'zh', 'fr', 'es', 'ko'];

export interface Attribution {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  landing_lang?: string;
}

function clean(v: string | null): string | undefined {
  if (!v) return undefined;
  const s = v.trim().slice(0, MAX_LEN);
  // 英数字と - _ . のみ許可（それ以外は除去）
  const safe = s.replace(/[^A-Za-z0-9._-]/g, '');
  return safe || undefined;
}

/** アプリ起動時に1回呼ぶ */
export function captureAttribution(): void {
  try {
    const sp = new URLSearchParams(window.location.search);
    const next: Attribution = {};
    for (const k of UTM_KEYS) {
      const v = clean(sp.get(k));
      if (v) next[k] = v;
    }
    if (!next.utm_source) return; // utm_source が無い遷移では既存値を維持
    const lng = sp.get('lng');
    if (lng && LANGS.includes(lng)) next.landing_lang = lng;
    sessionStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* sessionStorage が使えない環境では何もしない */
  }
}

export function getAttribution(): Attribution {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return {};
    const obj = JSON.parse(raw);
    return obj && typeof obj === 'object' ? (obj as Attribution) : {};
  } catch {
    return {};
  }
}
